<!-- 由 suu 创建于 2025-09-03 星期三 -->
<template>
  <div class="my-coach-team">
    <div v-if="info">
      <div class="team-header" v-if="info.vice_coach">
        <template v-if="info.vice_coach && info.change">
          <div class="team-main">
            <div class="main-top">
              <div class="top-title">您的专属训练规划师发生变更</div>
            </div>
            <div class="main-change">
              <div class="change-item">
                <img
                  class="change-item-img"
                  :src="info.change.old_image"
                  alt=""
                />
                <div class="change-item-info">
                  <div class="change-item-name">{{ info.change.old_name }}</div>
                  <div class="change-item-shop">{{ info.change.old_shop }}</div>
                </div>
              </div>
              <img
                class="change-img"
                src="https://cdnvue.gymcity.com.cn/uploads/coach-team-change"
                alt=""
              />
              <div class="change-item">
                <img
                  class="change-item-img"
                  :src="info.change.new_image"
                  alt=""
                />
                <div class="change-item-info">
                  <div class="change-item-name">{{ info.change.new_name }}</div>
                  <div class="change-item-shop">{{ info.change.new_shop }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="tips" v-if="info.change"
            >*如您还需试课，可于<span class="bold">{{
              info.change.last_date
            }}</span
            >前反馈</div
          >
          <div class="experience-survey">
            <div class="experience-title">您对更换结果是否满意？</div>
            <div class="experience-btn-list">
              <div class="experience-btn-item" @click="bindClickFeedBack(2)"
                >不满意</div
              >
              <div class="experience-btn-item" @click="bindClickFeedBack(1)"
                >满意</div
              >
            </div>
          </div>
        </template>
        <template v-if="info.vice_coach && !info.change">
          <div class="main-coach-container">
            <div class="main-top">
              <div class="top-title">专属训练规划师</div>
              <div class="top-btn user-btn" @click="bindReplaceCoach">
                我想更换
              </div>
            </div>
            <div class="main-coach">
              <CoachTeamItem :info="info.vice_coach" />
            </div>
          </div>
        </template>
      </div>
      <div class="team-list">
        <div class="list-item" v-for="(item, index) in info.list" :key="index">
          <CoachTeamItem :info="item" />
        </div>
      </div>
      <div v-if="!info.vice_coach && !info.list.length" class="coach-empty">
        <img
          class="empty-image"
          src="https://btw-common-data.betterwestar.com/btw-admin/resource/c6909e87377d090f266d8b1e7f1852c5_wh=642_339.png"
          alt=""
        />
        <div>暂无私教</div>
      </div>
    </div>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <ReplaceToast
        v-if="info && info.vice_coach"
        :type="toastType"
        :phone="info.vice_coach.shop_manager_phone"
        @confirm="bindConfirmToast"
        @cancel="bindCancelToast"
      />
    </van-overlay>
  </div>
</template>

<script>
import CoachTeamItem from './ponents/CoachTeamItem.vue'
import ReplaceToast from './ponents/toast.vue'
export default {
  name: 'my-coach-team',

  components: {
    CoachTeamItem,
    ReplaceToast
  },

  props: {},

  data() {
    return {
      showOverlay: false,
      toastType: 1,
      info: null
    }
  },

  computed: {},

  watch: {},

  created() {
    this.getMyCoachData()
  },

  mounted() {},

  destroyed() {},

  methods: {
    bindClickFeedBack(type) {
      if (type == 1) {
        this.postMemberFeedback(type)
      } else {
        this.toastType = 3
        this.showOverlay = true
      }
    },
    async postMemberFeedback(type) {
      let res = await this.$http
        .post('member/AppEntrance', {
          a: 'sendMemberChangeFeedback',
          id: this.info.change.id,
          type: type
        })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (type == 1) {
            this.$toast('感谢您的反馈~')
          } else {
            this.toastType = 4
            this.showOverlay = true
          }
          this.getMyCoachData()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getMyCoachData() {
      let res = await this.$http
        .get('member/AppEntrance', { a: 'getCoachListByClass' })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          /* res.data.change = {
            id:1,
            old_name:"暂时",
            old_image:"https://wegymercdn.gymcity.com.cn/coach_archives_3.0/5cb26fcf4152dfe2d2c0bddcf24177f9.png",
            old_shop:"星沙开源私教馆",
            new_name:"王五",
            new_image:"https://wegymercdn.gymcity.com.cn/coach_archives_3.0/5cb26fcf4152dfe2d2c0bddcf24177f9.png",
            new_shop:"星沙尚悦私教馆",
            last_date:"08.51",
          }; */
          this.info = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindReplaceCoach() {
      if (this.info.vice_coach.is_apply) {
        this.toastType = 2
        this.showOverlay = true
      } else {
        this.toastType = 1
        this.showOverlay = true
      }
    },
    bindConfirmToast() {
      this.showOverlay = false
      if (this.toastType == 1) {
        this.replaceCoach()
      } else if (this.toastType == 3) {
        this.postMemberFeedback(2)
      }
    },
    bindCancelToast() {
      this.showOverlay = false
      if (this.toastType == 2) {
        this.consultShopCoach()
      }
    },
    //更换教练
    async replaceCoach() {
      let res = await this.$http
        .get('member/ChangeApply', {
          a: 'saveApply',
          from_type: '3',
          flag: '1'
        })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.toastType = 2
          this.showOverlay = true
          this.getMyCoachData()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    //联系店长
    consultShopCoach() {
      window.location.href = `tel:${this.info.vice_coach.shop_manager_phone}`
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.my-coach-team {
  width: 100vw;
  min-height: 100vh;
  background-color: #fff;
  position: relative;

  .team-header {
    width: 100%;
    box-sizing: border-box;
    background-color: #f9f9f9;
    padding: 10px;

    .team-main {
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #f1f1f1;
      padding: 14px;
    }

    .main-coach-container {
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #f1f1f1;
      padding: 14px;
    }

    .main-top {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .top-title {
        font-size: 14px;
        color: #050b27;
      }

      .top-btn {
        font-weight: 500;
        font-size: 12px;
        color: #ff2270;
      }
    }

    .main-change {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 16px;

      .change-item {
        display: flex;
        align-items: center;
        justify-content: center;

        .change-item-img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 10px;
        }

        .change-item-info {
          .change-item-name {
            font-weight: 600;
            font-size: 14px;
            color: #050b27;
          }

          .change-item-shop {
            font-size: 10px;
            color: rgba($color: #050b27, $alpha: 0.5);
            margin-top: 3px;
          }
        }
      }

      .change-img {
        width: 64px;
      }
    }

    .main-coach {
      width: 100%;
      box-sizing: border-box;
      margin-top: 14px;
    }

    .experience-survey {
      margin-top: 10px;
      padding: 13px 30px 16px;
      background: linear-gradient(
          180deg,
          #feeede -13px,
          rgba(255, 255, 255, 0) 70px
        ),
        #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      border: 1px solid #ffffff;

      .experience-title {
        text-align: center;
        font-size: 14px;
        color: #050b27;
        line-height: 20px;
        margin-bottom: 16px;
      }

      .experience-btn-list {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .experience-btn-item {
          width: 140px;
          height: 28px;
          background: #f7f7f7;
          border-radius: 17px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          color: #303038;
        }
      }
    }
  }

  .team-list {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;

    .list-item {
      width: 100%;
      box-sizing: border-box;

      &:not(:last-child) {
        margin-bottom: 26px;
      }
    }
  }
}

.tips {
  margin-top: 5px;
  text-indent: 14px;
  font-size: 10px;
  color: rgba(5, 11, 39, 0.5);
  line-height: 14px;

  .bold {
    font-weight: bold;
    color: rgba(5, 11, 39, 1);
  }
}

.coach-empty {
  margin-top: 100px;
  font-size: 13px;
  color: rgba(51, 51, 51, 0.5);
  line-height: 18px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .empty-image {
    width: 214px;
    margin-bottom: 16px;
  }
}
</style>
